export enum SelectionOption {
  FULL_PAGE,
  FULL_GROUP,
  CUSTOM,
  NONE,
}

export type GroupSelectionType = Map<number, SelectionOption>
